<script>
    export default {
        inserted: function (element) {
            element.focus();
        }
    };
</script>


// WEBPACK FOOTER //
// resources/js/src/directives/Focus.vue